import { Component, Renderer2, Output, EventEmitter } from '@angular/core';
import templateString from './selectCustomer.component.html'
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  standalone: false,
  template: templateString
})
export class SelectCustomerComponent {
	@Output() action = new EventEmitter();
	
	public users;

	constructor(
		private bsModalRef: BsModalRef,
		private renderer: Renderer2
	) {
		// this.renderer.addClass(document.body, 'md-skin');
		// this.renderer.addClass(document.body, 'landing-page');
		// this.renderer.addClass(document.body, 'fixed-nav');
	}

	ok(customerId) {
		this.action.emit(customerId);
		this.bsModalRef.hide();
	}

  	dismiss() {
		this.bsModalRef.hide();
  	}

	cancel() {
		this.bsModalRef.hide();
	}
}